var feature;

feature = function() {
  var $, features, initSquare, modback, module, moduleName, modulesContainer, resizeBg, squareFeats, winHeight, winWidth;
  $ = require('jquery');
  moduleName = 'feature';
  module = $("." + moduleName);
  initSquare = require('../../../_scripts/functions/init-square');
  modback = module.find("." + moduleName + "__back>img");
  resizeBg = require('../../../_scripts/functions/resizebg');
  features = require('../../blocks/features/features');
  winWidth = $(window).width();
  modulesContainer = module.parents('.features');
  squareFeats = function() {
    return module.each(function() {
      var moduleWidth, thisMod, thisSwiper;
      thisMod = $(this);
      thisSwiper = thisMod.parents('.swiper-container');
      if (thisSwiper.length !== 0) {
        moduleWidth = thisSwiper.width();
      } else {
        moduleWidth = thisMod.width() + 100;
      }
      return thisMod.height(moduleWidth);
    });
  };
  if (winWidth >= 768 || modulesContainer.hasClass('features--unswipe')) {
    squareFeats();
  } else {
    initSquare(module);
    winHeight = $(window).height();
    if (winWidth > winHeight) {
      modback.css('width', '100%');
    } else {
      modback.css('height', '100%');
    }
  }
  $(window).resize(function() {
    features('resize');
    initSquare(module);
    resizeBg(modback);
    if (winWidth >= 768 || modulesContainer.hasClass('features--unswipe')) {
      return squareFeats();
    }
  });
  return resizeBg(modback);
};

module.exports = feature;
